var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { align: "center" } }, [
    _c("p", [_vm._v("¿Seguro de reenviar al SII?")]),
    _c(
      "div",
      { staticStyle: { "text-align": "right", "margin-top": "30px" } },
      [
        _c(
          "vs-button",
          {
            attrs: { color: "primary", type: "filled" },
            on: { click: _vm.reenviarDocumento }
          },
          [_vm._v("Reenviar documento")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }